module.exports = __webpack_public_path__ + "img/job-complete.abc78094.svg";